import { render, staticRenderFns } from "./TransferenciaDeInformacoesPosto.vue?vue&type=template&id=ae4ecf5e&"
import script from "./TransferenciaDeInformacoesPosto.vue?vue&type=script&lang=js&"
export * from "./TransferenciaDeInformacoesPosto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports